const SAFE_AREA_BOTTOM = 'var(--tg-viewport-safe-area-inset-bottom, 0px)';

export const safeAreaBottomPlus = (px: number): string => `calc(${px}px + ${SAFE_AREA_BOTTOM})`;
